export default __webpack_public_path__ + "static/c-exterior-754a0cf79d0eca436151780ddc75285c.jpg";